import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-24" }
const _hoisted_2 = { class: "text-3xl text-center font-bold mt-9" }
const _hoisted_3 = { class: "mt-4 text-center font-medium text-xs text-portal-darkgrey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CpsButton = _resolveComponent("CpsButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "wallet-not-available" }, null, -1)),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("Deposit_Wallet_Not_Available")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.t("Deposit_Wallet_Not_Available_Desciption")), 1)
    ]),
    _createVNode(_component_CpsButton, {
      class: "mt-11 mx-auto w-7/12",
      onClick: _ctx.restart
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("Deposit_Wallet_Not_Available_Return")), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}